const Sku = () => {
    return (
        <>
            <p className="text-ec-placeholder font-inter font-normal text-base leading-[26px]">
                SKU: AV01-D-31
            </p>
        </>
    );
};

export default Sku;
